import React from "react";

function Privacy(){
    return(
        <div>
            <div className="pageBanner lifeAtELite_banner">
                <div className="bannerCover d-flex  flex-column justify-content-center align-items-center text-center">
                    <h2 className='main_heading titleFont_style text-light pt-4'>Privacy Policy</h2>
                </div>
            </div>

            
            <section class="section_padding bg-light">
                <div class="container">
                    <p>
                        Please be assured that your personal information is kept private and confidential. 
                        Elite Techlogix does not share, sell, or disclose your personal data to any third party 
                        without your explicit consent.
                    </p>

                    <p>
                        Elite Techlogix is committed to protecting your privacy while you engage with our services.
                        This website is operated by <b>elitetechlogix.com</b>, and this Privacy Policy applies to
                        your use of any website or online platform managed under the domain <b>elitetechlogix.com</b>.
                    </p>

                    <p>
                        We have established this policy to explain what personal information we collect, 
                        how we use it, who has access to it, and what rights you have regarding your data. 
                        By visiting <b>elitetechlogix.com</b>, you acknowledge and accept the practices outlined in this Privacy Policy.
                    </p>

                    <p>
                        Comments, questions, or requests related to our privacy policy are always welcome and 
                        should be directed to our <b>Customer Support team</b>.
                    </p>

                    <h4>PERSONAL DATA</h4>

                    <p>
                        Elite Techlogix take responsibility for all the personal data 
                        (such as your name, address, email address, phone number, date of birth 
                        and financial or credit card information) that you share with us during inquiries, 
                        service requests, or business communications. This information is collected solely to 
                        facilitate our services and maintain effective communication with our valued clients.
                    </p>

                    <h4>LOCATION USAGE</h4>

                    <p>
                        By using our website, you (the visitor) agree to allow third parties to process 
                        your IP address, in order to determine your location for the purpose of currency 
                        conversion. You also agree to have that currency stored in a session cookie in 
                        your browser (a temporary cookie which gets automatically removed when you close your browser). 
                        We do this in order for the selected currency to remain selected and consistent when browsing 
                        our website so that the prices can convert to your (the visitor) local currency.
                    </p>
                </div>
            </section>
        </div>
    )
}

export default Privacy;